export default async () => {
  // TODO: 完成用户自动登录
}
